import { RequestConfig } from '@/interface'

const PRIFIX = 'fpgl/kprgl/'
const blacklistConfig: RequestConfig = {
  // 删除黑名单
  delHmd: {
    url: `${PRIFIX}delHmd`,
    method: 'post'
  },
  // 获取黑名单基本信息
  getHmdjbxx: {
    url: `${PRIFIX}getHmdjbxx`,
    method: 'get'
  },
  // 获取开票人基本信息
  getKprjbxx: {
    url: `${PRIFIX}getKprjbxx`,
    method: 'get'
  },
  // 黑名单列表
  hmdList: {
    url: `${PRIFIX}hmdList`,
    method: 'post'
  },
  // 添加或者更新开票人基本信息
  saveOrUpdate: {
    url: `${PRIFIX}saveOrUpdate`,
    method: 'post'
  },
  // 添加或者更新黑名单
  saveOrUpdateHmd: {
    url: `${PRIFIX}saveOrUpdateHmd`,
    method: 'post'
  },
  // 黑名单列表-下载导出
  hmdDownload: {
    url: `${PRIFIX}hmdDownload`,
    method: 'post'
  }
}
export default blacklistConfig
